import numeral from "./numeral"

export default class Input {

  static maskInteger() {

    const selector = ".integer:not([readonly])"

    $(selector).prop("type", "tel")
    $(selector).mask("0000.0000.000", { reverse: true, placeholder: "0" })
  }

  static integerToString(value) {
    return value ? numeral(value).format("0,0") : ""
  }

  static stringToInteger(str) {
    return numeral(str).value() || 0
  }

  static maskFloat() {
    return Input.maskCurrency({ disablePrefix: true })
  }

  static maskCurrency(settings) {

    if (!settings)
      settings = {}
    
    let selector = settings.selector || ".money"
    
    selector += ":not([readonly])"    
    
    let prefix = settings.prefix || "R$  "

    if (settings.disablePrefix)
      prefix = ""

    const data = {
      allowNegative: false,
      thousands: ".",
      decimal: ",",
      prefix,
    }    

    $(selector).prop("type", "tel")
    $(selector).prop("placeholder", prefix + "0,00")
    $(selector).maskMoney(data)

    const fourDecSelector = `${selector}-four-dec:not([readonly])`

    $(fourDecSelector).prop("type", "tel")
    $(fourDecSelector).prop("placeholder", prefix + "0,0000")
    $(fourDecSelector).maskMoney({ ...data, precision: 4 })
  }

  static floatToString(value) {
    
    let str = value ? numeral(value).format("0,0.00") : ""

    return str
  }

  static floatWith4DecimalsToString(value) {
    
    let str = value ? numeral(value).format("0,0.0000") : ""

    return str
  }

  static currencyToString(value, prefix) {

    if (!value)
      return null

    let str = value ? numeral(value).format("0,0.00") : ""

    if (!prefix)
      prefix = "R$ "
    
    str = prefix + str

    return str
  }

  static currencyWith4DecimalsToString(value, prefix) {

    let str = value ? numeral(value).format("0,0.0000") : ""

    if (!prefix)
      prefix = "R$ "

    str = prefix + str

    return str
  }

  static stringToCurrency(str) {
    return Input.stringToFloat(str)
  }

  static stringToFloat(str) {
    return numeral(str).value() || 0
  }
}